<div class="loading-container" *ngIf="!recallLoaded">
    <circular-indicator [size]="100"></circular-indicator>
</div>

<div *ngIf="recallLoaded && recallHistory === undefined" class="revision-wrapper">
    <app-no-content *ngIf="recallHistory === undefined" type="{{ 'no-recall.title' | translate}}" [vin]="vin"></app-no-content>
</div>

<div class="revision-wrapper" *ngIf="recallLoaded && recallHistory !== undefined">
  <lib-card
    *ngIf="lastPrintDate && country === 'BRA'"
    class="recall__card"
    [title]="'recall.certificate' | translate"
    [subtitle]="[('recall.updated' | translate), lastPrintDate]"
    [icon]="showDownloadButton() ? 'icon_download' : null"
    (iconClicked)="generatePdf()"
  ></lib-card>

  <div *ngFor="let r of recallHistory">

    <lib-accordion [header]="('recall' | translate) + getFullDate(r.launchDate)" foreground="light">
      <!-- data e hora -->
      <app-card
        *ngIf="r.repairDate"
        title="{{ 'date' | translate | uppercase }}"
        text="{{ r.repairDate }}"
      ></app-card>

      <!-- dealer -->
      <app-card
        *ngIf="r.dealerTradeName"
        title="{{ 'dealer' | translate | uppercase }}"
        text="{{ r.dealerTradeName }}"
        optional="{{r.dealerAddress }}"
      ></app-card>

      <!-- recall -->
      <app-card
        *ngIf="r.govtRecallNumber || r.id"
        title="{{('recall' | translate) + ' ' + (r.govtRecallNumber || r.id)}}"
        text="{{ r.localFsaDescLocal }}"
      ></app-card>
    </lib-accordion>

  </div>

</div>
